var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._t("default", function () {
    return [_c('social-contact')];
  }), _vm._v(" "), _c('div', {
    staticClass: "con_r"
  }, [_c('span', [_c('a', {
    staticClass: "about",
    attrs: {
      "target": "_blank",
      "href": _vm.getLink('/faq/index.html')
    }
  }, [_vm._v("About Us\n                ")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.getLink('/protocol/privacy_new.html')
    }
  }, [_vm._v("Privacy\n                ")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.getLink('/protocol/refund.html')
    }
  }, [_vm._v("Refund Policy\n                ")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.getLink('/protocol/terms_new.html')
    }
  }, [_vm._v("Terms\n                ")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.getLink('/protocol/cookie.html')
    }
  }, [_vm._v("Cookie Policy\n                ")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.getLink('/protocol/california_notice.html')
    }
  }, [_vm._v("Privacy Notice\n                ")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.getLink('/protocol/user_choice.html')
    },
    on: {
      "click": function click($event) {
        return _vm.clickga('User_Choice');
      }
    }
  }, [_vm._v("User's Choice\n                ")]), _vm._v(" "), _c('i')]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.getLink('/protocol/contact.html')
    },
    on: {
      "click": function click($event) {
        return _vm.clickga('Contact');
      }
    }
  }, [_vm._v("Contact Us\n                ")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.getLink('/protocol/intellectual.html')
    }
  }, [_vm._v("\n                    INTELLECTUAL PROPERTY RIGHTS\n                    "), _c('i')])]), _vm._v(" "), _c('span', [_vm._v("© " + _vm._s(_vm.crtime) + " " + _vm._s(_vm.companyName) + "\n            ")]), _vm._v(" "), _vm._m(0)])], 2)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('img', {
    staticClass: "qianhai",
    attrs: {
      "src": require("./images/qianhai1.png")
    }
  })]);
}];
export { render, staticRenderFns };